import React from "react";
import "../../styles/Users/adduser.css";
function Adduser(props) {
  const {
    user,
    handleAddUserPopup,
    handleUserDetails,
    handleAddUser,
    isuseredit,
    handleUpdateUser,
  } = props;
  return (
    <div className="overlay">
      <div className="licenceassign_container">
        <div className="d-flex justify-content-between align-items-center">
          <span className="header">
            {isuseredit ? "Update" : "Assign"} user
          </span>
          <button onClick={handleAddUserPopup} className="close">
            X
          </button>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="d-flex flex-column my-2 w-100">
            <span className="hint_text">Name</span>
            <input
              type="text"
              placeholder="Enter name"
              name="Name"
              value={user.Name}
              onChange={handleUserDetails}
              className="input_contianer"
            />
          </div>
          <div className="d-flex flex-column my-2 w-100">
            <span className="hint_text">Mail</span>
            <input
              type="email"
              placeholder="Enter mail"
              name="Email"
              value={user.Email}
              onChange={handleUserDetails}
              className="input_contianer"
            />
          </div>
          <div className="d-flex flex-column my-2 w-100">
            <span className="hint_text">Phone Number</span>
            <input
              type="text"
              placeholder="Enter phone number"
              name="PhoneNumber"
              value={user.PhoneNumber}
              onChange={handleUserDetails}
              className="input_contianer"
            />
          </div>

          <button
            onClick={isuseredit ? handleUpdateUser : handleAddUser}
            className="btn submit_btn"
          >
            {isuseredit ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Adduser;
